export type TableAction = 'Create' | 'Edit' | 'View'
export enum TABLE_ACTION {
  CREATE = 'Create',
  EDIT = 'Edit',
  VIEW = 'View',
}
